module.exports = __webpack_public_path__ + "static/media/adobe.2d1ced52.svg";